// subscription request
export const SUBSCRIPTION_REQUEST_POST = 'SUBSCRIPTION_REQUEST_POST'
export const SUBSCRIPTION_REQUEST_POST_SUCCESS
  = 'SUBSCRIPTION_REQUEST_POST_SUCCESS'
export const SUBSCRIPTION_REQUEST_POST_ERROR
  = 'SUBSCRIPTION_REQUEST_POST_ERROR'
